<template>
    <v-container id="reg-container" fill-height fluid class="px-2 px-sm-10">

        <v-row>

            <v-col cols="12" md="5">

            </v-col>

            <v-col cols="12" md="7">

                <v-card class="input-box pa-5">
                    <v-card-title primary-title class="justify-center">
                      <div>
                        <h2>Register</h2>                        
                      </div>
                    </v-card-title>
                    <v-card-text>
                        <v-form v-model="formIsValid" ref="form">

                          <v-row>
                            <v-col md="6" cols="12" class="py-0">
                              <v-text-field
                                    label="Username"
                                    v-model="username"
                                    prepend-icon="mdi-account-circle"
                                    type="text"
                                    :rules="usernameRules"
                                    validate-on-blur
                                    required
                              />
                            </v-col>
                            <v-col md="6" cols="12" class="py-0">
                              <v-text-field
                                    label="Email"
                                    v-model="email"
                                    type="email"
                                    prepend-icon="mdi-at"
                                    :rules="emailRules"
                                    validate-on-blur
                                    required
                              />
                            </v-col>
                          </v-row>

                          <div class="name-box my-4">

                            <v-row>
                              <v-col md="6" cols="12" class="py-0">
                                <v-text-field
                                      label="First Name"
                                      v-model="firstname"
                                      prepend-icon="mdi-alpha-f-circle-outline"
                                      type="text"
                                      :rules="fNameRules"
                                      validate-on-blur
                                      required
                              />
                              </v-col>
                              <v-col md="6" cols="12" class="py-0">
                                <v-text-field
                                            label="Surname"
                                            v-model="surname"
                                            prepend-icon="mdi-alpha-s-circle-outline"
                                            type="text"
                                            :rules="sNameRules"
                                            validate-on-blur
                                            required
                                    ></v-text-field>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col>
                                <v-btn block color="secondary" @click="generateName">
                                  <span class="hidden-xs-only">Or, Generate Fake Name</span>
                                  <span class="hidden-sm-and-up">Make a Fake</span>
                                </v-btn>
                              </v-col>
                            </v-row>

                          </div>

                          <v-row>
                            <v-col md="6" cols="12" class="py-0">
                              <v-text-field
                                    label="Password"
                                    v-model="password"
                                    type="password"
                                    prepend-icon="mdi-lock"
                                    :rules="passwordRules"
                                    validate-on-blur
                                    required
                            />
                            </v-col>
                            <v-col md="6" cols="12" class="py-0">
                              <v-text-field
                                    label="Confirm Password"
                                    v-model="password_confirmation"
                                    type="password"
                                    prepend-icon="mdi-lock-check"
                                    :rules="passwordConfirmationRules"
                                    validate-on-blur
                                    required
                            />
                            <v-checkbox
                              class="d-none"
                              v-model="click_me"
                              label="Click Me!"
                              value="1"
                            ></v-checkbox>
                            </v-col>
                          </v-row>

                          <v-row align="center">
                            <v-col cols="8" class="text-right pa-0 pb-4 pr-3">
                                <div>Get prediction reminder emails (recommended)?</div>
                            </v-col>
                            <v-col cols="4" class="pa-0">
                                <v-radio-group v-model="prefEmailReminder" row :rules="prefEmailReminderRules" class="mt-0">
                                    <v-radio label="Yes" value="1"></v-radio>
                                    <v-radio label="No" value="0"></v-radio>
                                </v-radio-group>
                            </v-col>
                          </v-row>

                          <v-row align="center">
                            <v-col cols="8" class="text-right pa-0 pb-4 pr-3">
                                <div>Get an email when the weekend's scores have been calculated (recommended)?</div>
                            </v-col>
                            <v-col cols="4" class="pa-0">
                                <v-radio-group v-model="prefEmailScores" row :rules="prefEmailScoresRules" class="mt-0">
                                    <v-radio label="Yes" value="1"></v-radio>
                                    <v-radio label="No" value="0"></v-radio>
                                </v-radio-group>
                            </v-col>
                          </v-row>

                        </v-form>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pa-4">
                        <v-btn type="submit" color="primary" @click="onRegister">Register</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn outlined color="secondary" to="/login">
                          <span class="d-none d-sm-inline d-md-none d-lg-inline">Already registered? Click here to log in</span>
                          <span class="d-inline d-sm-none d-md-inline d-lg-none">Log in</span>
                        </v-btn>
                    </v-card-actions>
                </v-card>
                

            </v-col>
        </v-row>

    </v-container>
</template>

<script>

  import { mapGetters, mapActions } from "vuex";

  export default {
    name: "Register",
    data() {
      return {
        email: '',
        username: '',
        password: '',
        password_confirmation: '',
        firstname: '',
        surname: '',
        click_me: 0,
        prefEmailReminder: null,
        prefEmailScores: null,
        fNameRules: [
          value => !!value || 'First name is required',
        ],
        sNameRules: [
          value => !!value || 'Surname is required',
        ],
        emailRules: [
          value => !!value || 'Email is required',
          value => /.+@.+/.test(value) || 'Email must be valid'
        ],
        usernameRules: [
          value => !!value || 'Username is required'
        ],
        passwordRules: [
          value => !!value || 'Password is required',
          value => value.length >= 8 || 'Password must be at least 8 characters'
        ],
        passwordConfirmationRules: [
          value => !!value || 'Password confirmation is required',
          value => value.length >= 8 || 'Password confirmation must be at least 8 characters',
          value => value === this.password || 'Password and confirmation do not match'
        ],
        prefEmailReminderRules: [
          value => !!value || 'Please select Yes or No',
        ],
        prefEmailScoresRules: [
          value => !!value || 'Please select Yes or No',
        ],
        formIsValid: false,
      }
    },
    computed: {
      ...mapGetters([
        'existingFullNames',
        'fnames',
        'snames',
      ]),
    },
    methods: {
      ...mapActions([
        'getNames',
      ]),
      onRegister() {
        if (this.click_me) {
          //BOT ALERT!
          return;
        }
        if (!this.$refs.form.validate()) {
          return;
        } else {
          this.$store.dispatch('regUser', {
            email: this.email,
            username: this.username,
            first_name: this.firstname,
            surname: this.surname,
            password: this.password,
            password_confirmation: this.password_confirmation,
            prefEmailReminder: this.prefEmailReminder,
            prefEmailScores: this.prefEmailScores,
          }).then(() => {
            this.$store.dispatch('getToken', {
              login: this.email,
              password: this.password
            }).then(() => {
              this.$store.dispatch('getUser')
              .then(() => {
                this.$store.dispatch('getCurrentWeek');
                this.$store.dispatch('getWeeks');
                this.$store.dispatch('getCurrentSeasonSdGames');
                this.$store.dispatch('getMaxGameWeek');
                this.$router.push({name: 'Home'})
              })
            })
          })
        }
      },
      generateName() {
        let fullName;
        let fNameIndex;
        let sNameIndex;
        let numFnames = this.fnames.length;
        let numSnames = this.snames.length;
        do {
          fNameIndex = Math.floor(Math.random() * numFnames);
          sNameIndex = Math.floor(Math.random() * numSnames);
          fullName = this.fnames[fNameIndex] + ' ' + this.snames[sNameIndex];
        } while (this.existingFullNames.indexOf(fullName) > -1)
        this.firstname = this.fnames[fNameIndex];
        this.surname = this.snames[sNameIndex];
        this.$refs.form.resetValidation()
      },
    },
    created() {
      this.getNames();

      window.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          this.onRegister();
        }
      });
    }
  }
</script>

<style scoped>

  #reg-container {
    background: url('../assets/images/10preglighter.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }

  .name-box {
      padding: 1.5rem;
      border: 2px solid var(--v-secondary-base);
      background-color: #ffffff;
  }

  .input-box {
      background-color: #EFEBE9;
      border-radius: 10px;
  }

  ::v-deep .v-input--radio-group .v-label {
    font-size: 0.875rem !important;
  }

</style>

